// extracted by mini-css-extract-plugin
export default {"parent":"ProyeccionCard_parent__9-Py5","parentBody":"ProyeccionCard_parentBody__rUc9z","child":"ProyeccionCard_child__mG+Qp"};